import { combineReducers } from "redux";
import profileSlice from "../store/slices/profile.slice";
import dateRangeSlice from "../store/slices/dateRange.slice";
import currentPlanSlice from "../store/slices/currentPlan.slice";
import documentCountSlice from "../store/slices/documentCount.slice";

const rootSlice = combineReducers({
    profile: profileSlice,
    dateRange: dateRangeSlice,
    currentPlan: currentPlanSlice,
    documentCount: documentCountSlice,
});

export default rootSlice;
